export const BikeStatus = {
  // 运营中
  WORKING: 2,
  // 暂停中
  PAUSING: 3,
  // 维修中
  FIXING: 4,
  // 生产中
  IN_PRODUCTION: 0,
  // 供应合格
  SUPPLY_OK: 5,
};

export const BikeColor = {
  BLACK: 1,
  RED: 2,
  YELLOW: 3,
  GREY: 4,
};

// 单车位置类型
export const BikePosType = {
  GPS: 0,
  GPRS: 1,
  MULTI: 2,
  USER: 3,
};

export const BikeAlertLvl = {
  LOW: 1,
  MIDDLE: 2,
  HIGHT: 3,
};

// 是否单车位置不是GPS定位
function isNotGPSPosType(posType) {
  return posType === BikePosType.GPRS || posType === BikePosType.MULTI;
}

// 是否包含高级别的警告
function containHighLvlAlertTypes(alertTypes) {
  if (alertTypes && alertTypes.length) {
    return alertTypes.some(type => type.level === BikeAlertLvl.HIGHT);
  }
  return false;
}

function isEmpty(arr) {
  return !arr || !arr.length;
}

export default class Bike {
  alertTypes;
  bikeId;
  bikeStatus;
  color;
  lng;
  lat;
  posType;
  positionTime;
  radius;
  runType;
  types;

  constructor(bikeInfo) {
    Object.assign(this, bikeInfo);
  }

  getBikeVisualType() {
    const notGps = isNotGPSPosType(this.posType);
    if (this.bikeId.bikeStatus === BikeStatus.WORKING && isEmpty(this.alertTypes)) {
      return { type: 'dot' };
    } else if (containHighLvlAlertTypes(this.alertTypes) || this.color === BikeColor.BLACK) {
      return { type: 'icon', color: 'black', notGps };
    } else if (this.color === BikeColor.RED) {
      return { type: 'icon', color: 'red', notGps };
    } else if (this.color === BikeColor.YELLOW) {
      return { type: 'icon', color: 'yellow', notGps };
    } else if (this.color === BikeColor.GREY) {
      return { type: 'icon', color: 'grey', notGps };
    }
    return { type: 'icon', color: 'green', notGps };
  }

  createMarkerHtml(label) {
    const visualInfo = this.getBikeVisualType();
    if (visualInfo.type === 'icon') {
      return {
        html: `<div class="monitor-bicycle ${visualInfo.color}
            ${visualInfo.notGps ? 'not-gps' : ''}">
            <span class="${label ? 'visible' : 'hidden'}">${label}</span>
            <i class="fa fa-bicycle1"></i>
          </div>`,
        size: 24,
      };
    }
    return {
      html: `<div class="monitor-bicycle monitor-bicycle-health">
        <span class="${label ? 'visible' : 'hidden'}">${label}</span>
       </div>`,
      size: 16,
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/monitorMap/bike.js